import { brand, memo, updatedAt } from '@/pages/menu-managements/const';
import { Title } from '@/pages/menu-managements/services/title';

export type Quantity = {
  min: '' | number;
  max: '' | number;
  max_same_option: '' | number;
};

export type OptionGroupForm = typeof optionGroupForm;

const title = {
  key: 'title',
  label: 'オプショングループ名',
} as const;
const optionItem = {
  key: 'option-item',
  label: 'オプション商品選択',
} as const;
const optionGroupItemNum = {
  key: 'option_group_item_num',
  label: 'オプショングループ内商品・個数設定',
} as const;
const min = {
  key: 'min',
  label: '顧客による選択必須のオプションの最小数',
} as const;
const max = {
  key: 'max',
  label: '顧客が選択できるオプションの最大数',
} as const;
const maxSameOption = {
  key: 'max_same_option',
  label: '注文者が同一オプションを選択できる最大回数',
} as const;
export const takeout = {
  pos_code: {
    key: 'pos_code',
    label: 'POSコード・テイクアウト',
  },
};
export const delivery = {
  pos_code: {
    key: 'pos_code',
    label: 'POSコード・デリバリー',
  },
};
export const eatIn = {
  pos_code: {
    key: 'pos_code',
    label: 'POSコード・イートイン',
  },
};

export const optionGroupForm = {
  brand,
  title,
  optionItem,
  optionGroupItemNum,
  memo,
  min,
  max,
  maxSameOption,
  takeout,
  eatIn,
  delivery,
} as const;

const tableColumns = [
  {
    ...title,
    width: '200px',
  },
  {
    ...memo,
    width: '200px',
  },
  {
    ...updatedAt,
    width: '180px',
  },
] as const;

export const optionGroupTableThs = tableColumns.map((tableColumn) => {
  return {
    label: tableColumn.label,
    minWidth: tableColumn.width,
  };
});

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const uberPermittedValue = (
  uberMinPermitted: number | '',
  uberMaxPermitted: number | ''
) => {
  const uber = {
    min_permitted:
      uberMinPermitted === 0 || uberMinPermitted === ''
        ? undefined
        : uberMinPermitted,
    max_permitted:
      uberMaxPermitted === 0 || uberMaxPermitted === ''
        ? undefined
        : uberMaxPermitted,
  };

  return Object.values(uber).filter((state) => state !== undefined).length !== 0
    ? uber
    : undefined;
};

export type MenuManagementOptionGroup = {
  id: number;
  title: Title;
  memo: string | null;
  updated_at: Date;
};

export type OptionGroupTakeout = {
  pos_code: string;
};

export type OptionGroupEatIn = {
  pos_code: string;
};

export type OptionGroupDelivery = {
  pos_code: string;
};
